import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CustomHeader from '../../General/CustomHeader';
import { ALL_ALERTS_LIST_UI } from './constants';
import AlertsTab from './AlertsTab';

const AlertsListView = () => (
  <Container maxWidth={false}>
    <Box mt={4}>
      <CustomHeader title="Alertas" showBackButton={false} />
    </Box>
    <Box mt={5}>
      <AlertsTab
        headers={ALL_ALERTS_LIST_UI}
        extraColumns={(alert) => ({
          sector: alert.sectorName || alert.sectorId,
          chart: alert.chart,
        })}
        sectorId={undefined}
        chartName={undefined}
      />
    </Box>
  </Container>
);

export default AlertsListView;
